import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

const SlideUp = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const severityColors = {
  success: {
    background: '#1a3d1a',
    border: '1px solid #67d36d',
    text: '#67d36d'
  },
  error: {
    background: '#3d1a1a',
    border: '1px solid #e53935',
    text: '#ff6b6b'
  },
  warning: {
    background: '#3d3a1a',
    border: '1px solid #efbc00',
    text: '#efbc00'
  }
};

const CustomAlertDialog = ({ open, onClose, message, severity = 'success' }) => {
  const [internalOpen, setInternalOpen] = useState(open);

  useEffect(() => {
    if (open) {
      setInternalOpen(true);
      const timer = setTimeout(() => {
        handleClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [open]);

  const handleClose = () => {
    setInternalOpen(false);
    onClose?.();
  };

  const style = severityColors[severity] || severityColors.success;

  return (
    <Dialog
      open={internalOpen}
      onClose={handleClose}
      TransitionComponent={SlideUp}
      keepMounted
      PaperProps={{
        style: {
          backgroundColor: style.background,
          border: style.border,
          color: style.text,
          padding: '16px 24px',
          borderRadius: 12,
          width: '90%',
          maxWidth: 400,
          boxShadow: '0 8px 24px rgba(0, 0, 0, 0.4)',
          position: 'fixed',
          bottom: 20,
          left: 20,
          margin: 0,
        },
      }}
      hideBackdrop
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
        <div style={{ fontSize: 18, lineHeight: 1.4 }}>{message}</div>
        <IconButton size="small" onClick={handleClose} style={{ color: style.text, marginLeft: 10 }}>
          <CloseIcon />
        </IconButton>
      </div>
    </Dialog>
  );
};

export default CustomAlertDialog;
